import { FC, useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Button, DatePicker, Form, Input, InputNumber, message, Radio } from "antd";

import { useTranslation } from "react-i18next";

import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "antd/es/form/Form";
import moment from "moment";
import { UploadImg } from "../../../common/components/UploadImg";
import { MultiSelectSite } from "../../../module/site/component/multi.select.site";
import MyEditor from "../../../common/components/MyEditor";
import { MultiSelectCouponByType } from "src/module/coupon/component/MultiSelectCouponByType";
import recommendActivityListService from "src/module/recommend.activity/service/recommendActivityListService";

export const RecommendActivitylistDetail: FC = () => {
	const [editorLoading, setEditorLoading] = useState<boolean>(false);
	const { TextArea } = Input;
	const navigate = useNavigate();
	const { t } = useTranslation();
	const params = useParams();
	const [form] = useForm();
	const [firstOrder, setFirstOrder] = useState<number>();

	useEffect(() => {
		if (params.id) {
			recommendActivityListService.detail(Number(params.id)).then((res) => {
				if (res.data.code === 200) {
					form.setFieldsValue({
						...res.data.data,
						activityTime: [moment(res.data.data.beginDate), moment(res.data.data.endDate)],
					});
					setFirstOrder(res.data.data.isParticipateOrder);
					setEditorLoading(true);
				}
			});
		} else {
			setEditorLoading(true);
		}
	}, [form, params.id]);

	const onFinish = async (value: any) => {
		const param = {
			...value,
			activityTime: undefined,
			beginDate: value.activityTime[0].format("YYYY-MM-DD") + " 00:00:00",
			endDate: value.activityTime[1].format("YYYY-MM-DD") + " 23:59:59",
			type: 1,
			shopIds: value.shopId,
		};
		if (!params.id) {
			const { data } = await recommendActivityListService.add(param);
			if (data.code === 200) {
				message.success(t("success"));
				navigate("/activity/recommendActivity");
			} else {
				message.error(data.msg);
			}
		} else {
			const { data } = await recommendActivityListService.update({
				...param,
				id: Number(params.id),
			});
			if (data.code === 200) {
				message.success(t("success"));
				navigate("/activity/recommendActivity");
			} else {
				message.error(data.msg);
			}
		}
	};

	return (
		<Container>
			<Form labelCol={{ span: 4 }} wrapperCol={{ span: 12 }} style={{ padding: 20 }} onFinish={onFinish} form={form}>
				<Form.Item label={t("image")} name='imageUrl'>
					<UploadImg />
				</Form.Item>
				<Form.Item label={t("shareImage")} name='shareImage'>
					<UploadImg />
				</Form.Item>
				<Form.Item label={t("shopName")} name='shopId'>
					<MultiSelectSite />
				</Form.Item>
				<Form.Item label={t("activityName")} name='title'>
					<Input placeholder={t("activityName")} />
				</Form.Item>

				<Form.Item label={t("活动允许参加次数")} name='recommendGrantNum'>
					<InputNumber />
				</Form.Item>
				<Form.Item label={t("限制每人参加次数")} name='recommendLimitNum'>
					<InputNumber />
				</Form.Item>
				<Form.Item label={t("activityTime")} name='activityTime'>
					<DatePicker.RangePicker />
				</Form.Item>
				<Form.Item label={t("注册用户获取优惠券组合")} name='registerNewGrantCouponIds'>
					<MultiSelectCouponByType />
				</Form.Item>
				<Form.Item label={t("推荐用户获取优惠券组合")} name='registerOldGrantCouponIds'>
					<MultiSelectCouponByType />
				</Form.Item>
				<Form.Item label={t("isParticipateOrder")} name='isParticipateOrder'>
					<Radio.Group
						onChange={(e) => {
							setFirstOrder(Number(e.target.value));
						}}
					>
						<Radio value={0}>{t("no")}</Radio>
						<Radio value={1}>{t("yes")}</Radio>
					</Radio.Group>
				</Form.Item>

				{firstOrder === 1 && (
					<>
						<Form.Item label={t("首单注册用户获取优惠券组合")} name='firstOrderNewGrantCouponIds'>
							<MultiSelectCouponByType />
						</Form.Item>
						<Form.Item label={t("首单推荐用户获取优惠券组合")} name='firstOrderOldGrantCouponIds'>
							<MultiSelectCouponByType />
						</Form.Item>
					</>
				)}

				<Form.Item label={t("sort")} name='sort'>
					<Input placeholder={t("sort")} />
				</Form.Item>

				<Form.Item label={t("status")} name='status'>
					<Radio.Group>
						<Radio value={1}>{t("onSale")}</Radio>
						<Radio value={2}>{t("off")}</Radio>
					</Radio.Group>
				</Form.Item>
				<Form.Item label={t("isHomePageShow")} name='isHomePageShow'>
					<Radio.Group>
						<Radio value={0}>{t("no")}</Radio>
						<Radio value={1}>{t("yes")}</Radio>
					</Radio.Group>
				</Form.Item>
				<Form.Item label={t("url")} name='contentUrl'>
					<Input  placeholder={t("url")} />
				</Form.Item>
				<Form.Item label={t("activityBriefly")} name='sketch'>
					<TextArea rows={4} placeholder={t("activityBriefly")} />
				</Form.Item>
				<Form.Item label={t("activityRule")} name='rule'>
					{editorLoading && <MyEditor />}
				</Form.Item>
				<Form.Item label={t("activityContent")} name='content'>
					{editorLoading && <MyEditor />}
				</Form.Item>
				<Form.Item wrapperCol={{ span: 12, offset: 4 }}>
					<Button type='primary' htmlType='submit'>
						{t("submit")}
					</Button>
				</Form.Item>
			</Form>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;
`;
